import React, { FC, useEffect } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { loadSingleBatch } from '@reducers/batch';
import { useRoute } from '@react-navigation/native';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';
import { parseRouteParamAsNumber } from '@helpers';

interface NCFileDetailsNCFileEventsCycleProps {}

const NCFileDetailsNCFileEventsCycleComponent: FC<NCFileDetailsNCFileEventsCycleProps> = ({
  getProductionBatchByNCFile,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
}) => {
  const route = useRoute();
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
    loadSingleBatch,
  });

  const ncFileId = parseRouteParamAsNumber(route.params?.ncFileId);

  useEffect(() => {
    if (ncFileId) {
      trackEvent(TRACKING_EVENTS.TIMES, {
        action: 'opened',
        perspective: 'ncFile' as const,
        ncFileId: String(ncFileId),
      });
    }
  }, [ncFileId]);

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CYCLE, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileEventsCycle = connect(null, {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
})(NCFileDetailsNCFileEventsCycleComponent);

export { NCFileDetailsNCFileEventsCycle };
